"use client";

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { format } from "date-fns";
import _ from "lodash";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface HeavyChartProps {
  title?: string;
}

const HeavyChart: React.FC<HeavyChartProps> = ({
  title = "Heavy Chart Component",
}) => {
  // Simulate some heavy data processing using lodash
  const generateData = () => {
    const rawData = _.range(1, 13).map((month) => ({
      month: format(new Date(2024, month - 1, 1), "MMM"),
      value: _.random(10, 100),
    }));

    return {
      labels: rawData.map((item) => item.month),
      datasets: [
        {
          label: "Sample Data",
          data: rawData.map((item) => item.value),
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          borderColor: "rgba(53, 162, 235, 1)",
          borderWidth: 1,
        },
      ],
    };
  };

  const data = generateData();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg border">
      <h3 className="text-lg font-semibold mb-4 text-gray-800">{title}</h3>
      <div className="h-80">
        <Bar data={data} options={options} />
      </div>
      <p className="text-sm text-gray-600 mt-4">
        This component includes Chart.js (~200KB), Lodash (~70KB), and date-fns
        (~20KB)
      </p>
    </div>
  );
};

export default HeavyChart;
